import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { TbConfetti } from "react-icons/tb";

function SubmitButton() {
  const { t } = useTranslation();

  return (
    <Button
      icon={<TbConfetti />}
      htmlType="submit"
      iconPosition="end"
      type="primary"
      form="billing-onboarding-form"
    >
      {t("complete")}
    </Button>
  );
}

export default SubmitButton;
